module.exports = __webpack_public_path__ + "img/HP-sec06-image-01-Germany.fa7f37d9.svg";